import { Accordion as Accordion$1 } from './src/Accordion.js';
import { Item } from './src/AccordionItem.js';

const Accordion = Accordion$1;
Accordion.Item = Item;

export { Accordion };
//# sourceMappingURL=index.js.map
